import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@components/App'
import * as Sentry from '@sentry/capacitor'
import * as SentryReact from '@sentry/react'
import env from '@consts/consts'
import { clarity } from 'react-microsoft-clarity'

if (env.IS_PRODUCTION && !!env.SENTRY_DSN) {
  Sentry.init(
    {
      dsn: env.SENTRY_DSN,
      integrations: [
        SentryReact.browserTracingIntegration(),
        SentryReact.replayIntegration()
      ] as any[],
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', env.API_BASE_URL as string],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    },
    // Forward the init method from @sentry/react
    SentryReact.init
  )
}

if (env.IS_PRODUCTION && !!env.CLARITY_ID) {
  clarity.init(env.CLARITY_ID)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
